<style lang="stylus">
.gift-card-rule
    &.show-header
      padding-top 44px
    .card-rule-text
        padding 15px
        h3:nth-child(1)
            margin-top 0px
        span.primary
            color rgb(255,95,22)
        ul
            padding-left 15px
            li
                color rgb(121,125,130)
                font-size 13px
        h3
            font-size 14px
            color rgb(25, 26, 27)

</style>
<template>
    <div :class="[isApp ? '' : 'show-header' , 'gift-card-rule']">
        <my-header class="header" v-show="!isApp">
        </my-header>
        <div class="card-rule-text">
            <h3>购买指定商品</h3>
            <ul>
                <li>
                    可兑换<span class="primary">{{ maxConsumePrice | price }}元</span>以下的指定商品1份，超过<span>{{ maxConsumePrice | price }}元</span>需补差价，低于<span>{{ maxConsumePrice | price }}元</span>不找零
                </li>
                <li>
                    购买指定商品时，该券与现金券不可叠加
                </li>
            </ul>
            <h3>购买非指定商品</h3>
            <ul>
                <li>
                    可兑换<span class="primary">{{ equalCash | price }}元</span>以下的非指定商品（任意品类）1份，超过<span>{{ equalCash | price }}元</span>需补差价，低于<span>{{ equalCash | price }}元</span>不找零
                </li>
                <li>
                    购买非指定商品时，该券与现金券可叠加
                </li>
            </ul>
            <h3>指定商品</h3>
            <ul>
                <li>
                    指定商品为：企业福利内所有礼包商品
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import myHeader from '../../components/header.vue'
    import { mapState } from 'vuex'
    import op from 'object-path'
    import _ from 'underscore'
    import { app } from '../../util/platform'

    export default {
        data() {
            return {
            }
        },
        components: {
            'my-header': myHeader,
        },
        mounted(){
            if(_.isEmpty(this.card)){
                this.$router.go(-1)
            }
        },
        computed: {
            ...mapState({
                card: state => state.card.cardDetail,
            }),
            isApp() {
              return app.isMZFilm()
            },
            equalCash() {
                return op(this.card).get('ticketInfo.equalCash')
            },
            maxConsumePrice() {
                return op(this.card).get('ticketInfo.maxConsumePrice')
            },
        }
    }
</script>
